module.exports = __webpack_public_path__ + "static/img/icon_status1.2c638f79.png";